import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { ManageUserPatientModel } from '../../../models/centre/manage-user-patient.model';
import { PatientUrl } from '../../../shared/urls/patient.url';
import { UserUrl } from '../../../shared/urls/user.url';
import { OrganizationUrl } from '../../../shared/urls/company-account.url';
import { CentreUrl } from '../../../shared/urls/centre.url';
import { Utility } from '../../../common/utility';
@Injectable()
export class ManagePatientAccountService {
    constructor(public baseService: BaseService) { }

    extractData(res: Response) {
        return res.json();
    }

    getInIt() {
        const url = PatientUrl.GET_PATIENT_INIT;
        return this.baseService.getData(url);
        // return data;
    }

    getPatientCount(param) {
        const url = PatientUrl.GET_LIST_PATIENT_ACCOUNT_COUNT;
        return this.baseService.getData(url, param);
    }
    getPatientsByEmail(param) {
        const url = PatientUrl.GET_LIST_PATIENT_BY_EMAIL;
        return this.baseService.getData(url, param);
    }
    getPatientList(param) {
        const url = PatientUrl.GET_LIST_PATIENT_ACCOUNT;
        return this.baseService.getData(url, param);
        // return data;
    }

    getCountryData() {
        const url = UserUrl.GET_USER_COUNTRY;
        return this.baseService.getData(url);
    }

    getCollege() {
        const url = PatientUrl.GET_COLLEGE;
        return this.baseService.getData(url);
    }

    getHealthInsurance() {
        const url = PatientUrl.GET_HEALTHINSURANCE;
        return this.baseService.getData(url);
    }

    getParty() {
        return this.baseService.getData(OrganizationUrl.ORGANIZATION_DROP_DOWN_LIST);
    }

    getTitleData() {
        const url = PatientUrl.GET_TITLE;
        return this.baseService.getData(url);
    }

    getSexData(): any[] {
        return [
            {
                id: 0,
                name: 'Male'
            },
            {
                id: 1,
                name: 'Female'
            }
        ];
    }

    getTypeParty() {
        let url = PatientUrl.GET_PARTY_TYPE;
        return this.baseService.getData(url);
    }

    updatePatientAccount(id, param) {
        let url = PatientUrl.EDIT_PATIENT_ACCOUNT + `${id}`;
        return this.baseService.update(url, param);
    }

    addPatientAccount(param, clinicId) {
        let url = PatientUrl.ADD_PATIENT_ACCOUNT;
        if (clinicId && clinicId !== "null")
            url += '?clinicId=' + clinicId;
        return this.baseService.postData(url, param);
    }

    deletePatient(id) {
        // let url = UserUrl.REMOVE_CENTRE_USER.replace('{userId}', id);
        let url = PatientUrl.REMOVE_PATIENT_ACCOUNT.replace('{id}', id);
        return this.baseService.delete(url);
    }

    /* getCurrentDate() {
         const datePipe = new DatePipe('en-US');
         return datePipe.transform(new Date(), 'dd MMM yyyy');
     }*/

    getPatientUser(id) {
        let url = PatientUrl.GET_PATIENT_ACCOUNT.replace('{id}', id);
        return this.baseService.getData(url);
        // return {
        //     id: '1',
        //     patientREF: 'HUN11253T',
        //     patientName: 'Hung Vuong',
        //     dateOfBirth: 1477195980,
        //     occupation: 'Engineer',
        //     email: 'hungvuong@haveynash.vn',
        //     address: 'Ba Hom street Ho Chi Minh',
        //     active: 1
        // };
    }

    disablePatient(param) {
        let url = Utility.stringFormat(PatientUrl.DISABLE_PATIENT, [param['id']]);
        return this.baseService.put(url, null);
    }

    addPatientToWaitingRoom(id: string, clinicId: string) {
        return this.baseService.postData(CentreUrl.ADD_PATIENT_TO_WAITING_ROOM.replace('{patientId}', id) + '?clinicid=' + clinicId, null);
    }

    generateOrgCode(name, country): string {
        if (name !== '') {
            const orgCode =
                name.substring(0, 3).toUpperCase() + country.toUpperCase();
            return orgCode;
        } else {
            return 'N/A';
        }
    }

    checkOrgCode(): void { }

    checkEmailExists(param) {
        const url = PatientUrl.CHECK_EMAIL_EXISTS;
        return this.baseService.getData(url, param);      
    }

    checkEnableMyTMBAccount(id) { 
        let url = PatientUrl.CHECK_CREATE_MyTMB.replace('{id}', id);
        return this.baseService.getData(url); 
    }


}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-patient-user/manage-patient.service.ts